/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Match_Score_MaxInputs */

const en_deep_match_score_max = /** @type {(inputs: Deep_Match_Score_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ 100`)
};

const de_deep_match_score_max = /** @type {(inputs: Deep_Match_Score_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ 100`)
};

const fr_deep_match_score_max = /** @type {(inputs: Deep_Match_Score_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ 100`)
};

const es_deep_match_score_max = /** @type {(inputs: Deep_Match_Score_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ 100`)
};

const it_deep_match_score_max = /** @type {(inputs: Deep_Match_Score_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ 100`)
};

const nl_deep_match_score_max = /** @type {(inputs: Deep_Match_Score_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ 100`)
};

const pl_deep_match_score_max = /** @type {(inputs: Deep_Match_Score_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ 100`)
};

const fi_deep_match_score_max = /** @type {(inputs: Deep_Match_Score_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ 100`)
};

const da_deep_match_score_max = /** @type {(inputs: Deep_Match_Score_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ 100`)
};

const sv_deep_match_score_max = /** @type {(inputs: Deep_Match_Score_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ 100`)
};

/**
* | output |
* | --- |
* | "/ 100" |
*
* @param {Deep_Match_Score_MaxInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const deep_match_score_max = /** @type {((inputs?: Deep_Match_Score_MaxInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Match_Score_MaxInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_deep_match_score_max(inputs)
	if (locale === "fr") return fr_deep_match_score_max(inputs)
	if (locale === "es") return es_deep_match_score_max(inputs)
	if (locale === "it") return it_deep_match_score_max(inputs)
	if (locale === "nl") return nl_deep_match_score_max(inputs)
	if (locale === "pl") return pl_deep_match_score_max(inputs)
	if (locale === "fi") return fi_deep_match_score_max(inputs)
	if (locale === "da") return da_deep_match_score_max(inputs)
	if (locale === "sv") return sv_deep_match_score_max(inputs)
	return en_deep_match_score_max(inputs)
});